export const actionTypes = {
	SetPosts: '[Social] SetPosts',
	ClearPosts: '[Social] ClearPosts',
};

export const initialSocialState = {
	instagram: [],
};

export const reducer = (state = initialSocialState, action) => {
	switch (action.type) {
		case actionTypes.SetPosts:
			return {
				...state,
				instagram: action.payload || [],
			};
		case actionTypes.ClearPosts:
			return {
				...state,
				instagram: [],
			};
		default:
			return state;
	}
};

export const actions = {
	setPosts: payload => ({ type: actionTypes.SetPosts, payload }),
	clearPosts: payload => ({ type: actionTypes.ClearPosts, payload }),
};
